import { DocumentOption } from 'containers/documents/allowed-documents-uploader';
import React from 'react';
import './upload.scss';

type NewDocumentSelectorProps = {
    documentOptions: DocumentOption[];
    setDocumentSelected: React.Dispatch<React.SetStateAction<DocumentOption>>;
};

const NewDocumentSelector: React.FC<NewDocumentSelectorProps> = ({
    documentOptions,
    setDocumentSelected }): JSX.Element => {

    console.log(documentOptions)
    return (
        <>
            <p className="body-1 mt-3">Para prosseguir escolha o tipo de documento que irá enviar.</p>
            <div className="options-content">
                {documentOptions.map((opt, index) => (
                    <button
                        key={index}
                        onClick={() => setDocumentSelected({ value: opt.value, label: opt.label })}>
                        <label>{opt.label}</label>
                    </button>
                ))}
            </div>
        </>
    );
};

export default NewDocumentSelector;
